// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__peMXi","newExpiryDate":"styles_newExpiryDate__17aGW","footer":"styles_footer__382pj"};